import React from "react";
import { useIsFetching, useIsMutating } from "react-query";
import { useSelector } from "react-redux";
import DotLoader from "react-spinners/DotLoader";

import "./GlobalSpinner.scss";

function GlobalSpinner(props) {
  const isLoading = useSelector(state => state.Loader);
  const isMutating = useIsMutating();
  const isFetching = useIsFetching();
  if (isLoading || isMutating) {
    return (<div className="spinner-container"><DotLoader size={60}  color="#36d7b7" /></div>)
  }
}

export default GlobalSpinner;
